<template>
    <div class="user-menu">
        <el-popover
            placement="bottom-end"
            :visible-arrow="false"
            popper-class="popover-container"
            trigger="hover">
            <div class="popover-box">
                <div v-for="(item,index) in collapseNavList" :key="index" class="popover--item" @click="navClick(item)">
                    <div class="title">
                        <i :class="item.icon"></i>
                        <span>{{ item.name }}</span>
                    </div>
                    <i class="el-icon-arrow-right"></i>
                </div>
            </div>
            <img class="user-icon" :src="userIcon" alt="" slot="reference">
        </el-popover>
        <el-dialog
            :title="$t('home.contacts')"
            :visible.sync="contactUsDialogVisible"
            :close-on-click-modal="false"
            append-to-body>
            <div v-html="contactUsData"></div>
            <div slot="footer">
                <el-button type="primary" @click="contactUsDialogVisible = false">{{$t('common.UI.button.confirm')}}</el-button>
            </div>
        </el-dialog>
        <el-dialog
            :title="$t('common.header.popup.log_out')"
            :visible.sync="logOutDialogVisible"
            :close-on-click-modal="false"
            append-to-body>
            <div>{{$t('common.header.popup.popup_confirm_logout')}}</div>
            <div slot="footer">
                <el-button @click="logOutDialogVisible = false">{{$t('common.UI.button.cancel')}}</el-button>
                <el-button type="primary" @click="onLogOut">{{$t('common.UI.button.confirm')}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<style>
.popover-container {
    min-width: 160px !important;
    padding: 0 !important;
}
</style>

<style lang="scss" scoped>
.popover-box {
    padding: 10px 0;
    .popover--item {
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 34px;
        width: 100%;
        padding: 0 10px;
        cursor: pointer;
        color: #666;
        .title {
            i {
                font-size: 16px;
            }
        }
        &:hover {
            background-color: #F5F5F5;
        }
    }
}
.user-icon {
    width: 42px;
    height: 42px;
    cursor: pointer;
}
</style>

<script>
import { commonParams } from '@/config/common'
import { mapState } from 'vuex'
import { PrivateDeploy } from '@/config/private-deploy'
import { Login } from '@/models/login'
import { PaasTenant } from '@/models/paas-tenant'
export default {
    props: {
        routes: Object
    },
    data() {
        return {
            collapseNavList: [
                {
                    name: this.$t('common.header.popup.log_out'),
                    type: 'LogOut',
                    icon: 'iconfont icon-paas_tuichu',
                }
            ],
            contactUsDialogVisible: false,
            logOutDialogVisible: false
        }
    },
    computed: {
        ...mapState(['loginInfo']),
        isPrivate() {
            return PrivateDeploy.isPrivate()
        },
        userIcon() {
            if(this.isPrivate) {
                return commonParams.CDN_URL + '/paas/www.isss.pku.edu.cn/head_pic.png'
            }
            return commonParams.CDN_URL + '/paas/img/head_pic.png'
        },
        contactUsData() {
            const val = this.$getConfigText(this.loginInfo.contactUs)
            if(!val) return ''
            return val.replace(/(\r\n|\r|\n)/g, '<br/>')
        }
    },
    created(){
        this.init()
    },
    methods: {
        init(){
            if(this.contactUsData) {
                this.collapseNavList.unshift({
                    name: this.$t('home.contacts'),
                    icon: 'el-icon-chat-dot-square',
                    type: 'ContactUs',
                })
            }
            PaasTenant.getTenantInfo().then(res => {
                if(res.subSystem) {
                    if(res.subSystem.includes(1) || res.subSystem.includes(2)) {
                        this.collapseNavList.unshift({
                            name: this.$t('paas_system.user.user_info'),
                            type: 'PersonalInfo',
                            icon: 'iconfont icon-paas_gerenxinxi',
                            path: '/personal',
                        })
                    }
                }
            })
        },
        navClick(obj) {
            if(obj.type === 'ContactUs') {
                this.contactUsDialogVisible = true
                return
            }else if(obj.type === 'LogOut') {
                this.logOutDialogVisible = true
                return
            }
            if(this.$route.path === obj.path) return
            this.$router.push(obj.path)
            this.routes.hideActive()
        },
        onLogOut() {
            Login.logOut().then(res => {
                if(this.isPrivate) {
                    this.$router.push('/emailLogin')
                }else {
                    window.location.href = Login.getLoginPrefix() + '#/account'
                }
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/layout/header/auth-menu/user-menu.vue